export default [
  {
    component: 'div',
    class: 'row',
    children: [
      {
        name: 'customPrice',
        label: 'Custom Price',
        type: 'number'
      }
    ]
  },
]